// export default OnlineOrderPDF
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/space-before-function-paren */
import React, { Fragment, useContext } from "react";
import LogoSVG from "../../assets/svg/Logo";
import { ApplicationState } from "../../services/context/ApplicationStateContext";
import useStateAndCity from "../../services/utils/custom hooks/useStateAndCity";
import {
  SCC_ADDITIONAL_HISTORY_OPTIONS,
  SCC_ADDITIONAL_PATHOLOGY_OPTIONS,
  SCC_AGGRESSIVE_SUBTYPE_FOOTNOTE,
  SCC_REQUIRED_FIELD_LABELS,
  SCC_REQUIRED_HISTORY_QUESTIONS,
  SCC_REQUIRED_PATHOLOGY_QUESTIONS,
} from "../../constants/sccClinicalInfoConfig";
import RadioOptions from "../../services/models/radioOptions.model";
import { normalizeSccClinicalSectionsFromApi } from "../../utils/helpers/sccClinicalSectionMapper";

// --- 1. CSS STYLES ---
const pdfStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap');
  .order-print-wrapper {
    display: block !important;
    width: 100%;
  }

  #pdf-container {
    font-family: 'Montserrat', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    color: #172b4d;
    background: #fff;
    padding: 30px 40px;
    font-size: 10px;
    line-height: 1.3;
    width: 100%;
    max-width: 1000px;
    margin: 0 auto;
    box-sizing: border-box;
    
    /* FORCE BREAK AFTER EACH ORDER */
    display: block !important;
    page-break-after: always !important;
    break-after: page !important;
    
    /* Ensure it takes up significant space */
    min-height: 290mm; /* Standard A4 height to help the browser identify pages */
    position: relative;
  }
    
  /* Prevent the last order from creating a trailing blank page */
  #pdf-container:last-child {
    page-break-after: auto !important;
    break-after: auto !important;
    min-height: auto;
  }

  #pdf-container * {
    box-sizing: border-box;
  }

  /* --- HEADER --- */
  .header-container {
    display: flex;
    justify-content: space-between;
    align-items: flex-end; /* Changed to flex-end to align bottom of logo with bottom of order box if needed, or flex-start */
    margin-bottom: 16px;
  }
  .org-info-container {
    flex: 1;
  }
  
  /* NEW: Right side column to stack Image and Order Type Box */
  .header-right-section {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 8px; /* Space between image and box */
  }
.test-logos-container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px; /* Space between the two test logos */
  margin-bottom: 8px;
}

  /* Logos stacked in a column inside the order-type box */
  .header-logos-column {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 8px;
    margin-bottom: 8px;
  }

  .order-type-image {
    width: 212px;
    max-width: 212px;
    height: 27.58px;
    max-height: 27.58px;
    object-fit: contain;
    object-position: right;
    display: block;
  }

  .company-logo-wrapper {
    margin-bottom: 8px;
  }
  .company-address, .company-phone {
    font-size: 9px;
    color: #475467;
    margin-bottom: 2px;
    font-weight: 400;
  }
  .phone-number {
    color: #18b5b7 !important;
    font-weight: 600;
  }
  .generated-date {
    font-size: 8px;
    color: #98a2b3;
    margin-top: 4px;
  }
  
  .order-type-box {
    border: 1px solid #18b5b7;
    border-radius: 6px;
    padding: 8px 16px;
    text-align: right;
    min-width: 200px;
    text-align: right;
  }
  .order-type-label {
    font-size: 8px;
    text-transform: uppercase;
    color: #667085;
    letter-spacing: 0.5px;
    font-weight: 500;
  }
  .order-type-value {
    font-size: 13px;
    font-weight: 700;
    color: #101828;
  }

  /* --- STATUS BAR --- */
  .status-bar {
    display: flex;
    align-items: center;
    border-top: 1px solid #e5e7eb;
    border-bottom: 1px solid #e5e7eb;
    padding: 8px 0;
    margin-bottom: 16px;
  }
  .status-item {
    font-size: 9px;
    color: #344054;
    display: flex;
    align-items: center;
  }
  .status-separator {
    margin: 0 12px;
    color: #d0d5dd;
    font-size: 12px;
    font-weight: 300;
  }
  .status-label {
    color: #475467;
    margin-right: 4px;
    font-weight: 400;
  }
  .status-val {
    font-weight: 600;
    color: #101828;
  }

  /* --- SECTIONS --- */
  .section-row {
    display: flex;
    gap: 16px;
    width: 100%;
    margin-bottom: 12px;
    align-items: stretch;
  }

  .lab-shipment-section-row {
    margin-top: 12px;
  }
  
  /* Generic Card Style */
  .section-card {
    background-color: #fff;
    border: 1px solid #D0D5DD; 
    border-radius: 8px;
    padding: 12px 16px;
    flex: 1;
    display: flex;
    flex-direction: column;
    page-break-inside: avoid;
    position: relative;
    height: 100%;
  }

  .additionalNotes-card {
    background-color: #F9FAFB;
    border: 1px solid #D0D5DD; 
    border-radius: 8px;
    padding: 12px 16px;
    flex: 1;
    display: flex;
    flex-direction: column;
    page-break-inside: avoid;
    position: relative;
    height: 100%;
  }

  /* SPECIAL: Patient Info gets the TEAL border (#18b5b7) */
  .patient-info-card {
    border: 1px solid #18b5b7 !important;
    border-left: 5px solid #18b5b7 !important;
  }

  .card-header {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
  
  .header-bullet {
    min-width: 6px;
    min-height: 6px;
    background-color: #18b5b7;
    border-radius: 50%;
    margin-right: 8px;
    display: inline-block;
  }

  .header-title {
    font-size: 10px;
    font-family: Montserrat;
    font-weight: 700;
    color: #18b5b7 !important; /* Force TEAL color */
    text-transform: uppercase;
    letter-spacing: 0.8px;
    line-height: 1;
  }
  .additionalNotes-title {
    font-size: 8px;
    font-weight: 400;
    color: #475467 !important; 
    text-transform: uppercase;
    letter-spacing: 0.4px;
    line-height: 1;
  }
  
  .additionalNotes-subtitle {
    font-size: 10px;
    font-weight: 400;
    color: #101828 !important;
    letter-spacing: 0.4px;
    line-height: 2.5;
  }

  /* --- FIELDS --- */
  .fields-grid {
    display: flex;
    gap: 20px;
  }
  .field-col {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  
  .field-row {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    width: 100%;
  }
  
  .field-label {
    font-size: 9px;
    color: #475467;
    font-weight: 400;
    flex-shrink: 0;
    width: 45%; 
    text-transform: capitalize;
    line-height: 13.5px;
  }
  
  .field-val {
    font-size: 9px;
    color: #101828;
    font-weight: 500; 
    text-align: left;
    flex: 1;
    word-wrap: break-word;
  }
  .onlineOrderHeading {
    font-family: Montserrat;
    font-weight: 400;
    font-style: Regular;
    font-size: 8px;
    leading-trim: NONE;
    line-height: 12px;
    letter-spacing: 0px;
    color: #000000;
  }

  /* Special Row Class for Signature/Headers to span full width */
  .full-width-row .field-label {
    width: auto; 
    flex: 1;
  }
  .full-width-row .field-val {
    flex: 0;
    white-space: nowrap;
    margin-left: 12px;
  }

  /* --- FOOTER / SIGNATURE --- */
  .footer-section {
    background: #f9fafb;
    border: 1px solid #98a2b3;
    border-radius: 6px;
    padding: 12px 16px;
    break-after: page;
    /* CRITICAL: Prevents signature from splitting across pages */
    page-break-inside: avoid !important;
    break-inside: avoid !important;
    display: block;
  }
  .footer-label {
    font-weight: 700;
    color: #667085;
    text-transform: uppercase;
    font-size: 10px;
    margin-bottom: 6px;
  }
    .signature-image-container {
    margin-top: 8px;
    display: block;
    page-break-inside: avoid !important;
  }

  .signature-image {
    max-width: 180px;
    max-height: 60px;
    object-fit: contain;
    display: block;
  }
  
  @media print {
    body { padding: 0; background: white; }
    #pdf-container { 
        padding: 15px 25px; 
        overflow: visible !important;
    }
    .section-card, .footer-section { 
        page-break-inside: avoid !important; 
        break-inside: avoid !important; 
    }
    .header-bullet { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
    .header-title { color: #18b5b7 !important; -webkit-print-color-adjust: exact; }
    .phone-number { color: #18b5b7 !important; -webkit-print-color-adjust: exact; }
    .patient-info-card { border: 1px solid #18b5b7 !important; border-left: 5px solid #18b5b7 !important; -webkit-print-color-adjust: exact; }
    .additionalNotes-card { background-color: #F9FAFB !important; -webkit-print-color-adjust: exact;}
    .lab-shipment-section-row {
      margin-top: 24px !important;
      padding-top: 8px;
    }
  }

  /* --- SCC CLINICAL INFORMATION --- */
  .scc-clinical-grid {
    display: flex;
    gap: 24px;
    width: 100%;
  }
  .scc-clinical-col {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  .scc-section-heading {
    font-size: 9px;
    font-weight: 700;
    color: #101828;
    text-transform: uppercase;
    margin-bottom: 10px;
  }
  .scc-subsection-heading {
    font-size: 9px;
    font-weight: 600;
    color: #101828;
    margin-bottom: 8px;
  }
  .scc-subsection-heading-spaced {
    margin-top: 12px;
  }
  .scc-required-block {
    margin-bottom: 10px;
  }
  .scc-required-question {
    font-size: 9px;
    font-weight: 600;
    color: #101828;
    line-height: 1.4;
    margin-bottom: 2px;
  }
  .scc-required-answer {
    font-size: 9px;
    font-weight: 400;
    color: #475467;
    line-height: 1.4;
  }
  .scc-additional-item {
    font-size: 9px;
    font-weight: 400;
    color: #101828;
    line-height: 1.4;
    margin-bottom: 8px;
  }
  .scc-additional-empty {
    font-size: 9px;
    font-weight: 400;
    color: #475467;
    line-height: 1.4;
    margin-bottom: 8px;
  }
  .scc-additional-footnote {
    font-size: 8px;
    font-weight: 400;
    color: #475467;
    line-height: 1.4;
    margin-top: 12px;
  }
`;

// --- 2. DATA CONSTANTS ---
const data = [
  {
    title: "Clinician Information",
    sections: [
      {
        fields: {
          name: "Organization Name",
          email: "Org Email",
          phone: "Phone",
          fax: "Fax",
          address: "Address",
          city: "City",
          state: "State",
          zipcode: "Zip",
        },
      },
    ],
  },
  {
    title: "Test Menu",
    sections: [],
  },
  {
    title: "Patient Information",
    sections: [
      {
        title: "Demographics",
        fields: {
          patient_firstname: "First Name",
          patient_middleinitial: "Middle Initial",
          patient_lastname: "Last Name",
          patient_dob: "DOB",
          patient_gender: "Sex",
        },
      },
      {
        title: "Contact",
        fields: {
          patient_email: "Email",
          patient_phone: "Phone",
          patient_address: "Address",
          patient_city: "City",
          patient_state: "State",
          patient_zip_code: "Zip",
        },
      },
    ],
  },
  {
    title: "Billing information",
    sections: [
      {
        fields: {
          icd_10: "ICD-10 Code",
          additionalCodes: "Add. ICD-10s",
          insurance: "Primary Ins. Co.",
          icn: "Ins. Co. Name",
          billing_phone: "Phone",
          policy: "Policy Number",
          medicare: "Facility Type",
          date_of_discharge: "Discharge Date",
        },
      },
    ],
  },
  {
    title: "Clinical Information",
    sections: [],
  },
  {
    // Note: We use this just for field mapping references, logic is custom below
    title: "Additional Information",
    sections: [
      {
        fields: {
          firstName: "First Name",
          lastName: "Last Name",
          email: "Email",
          fax: "Fax",
          npi: "NPI",
        },
      },
    ],
  },
  {
    title: "Laboratory Information",
    sections: [
      {
        fields: {
          name_of_facility: "Facility Name",
          date_of_collection: "Collection Date",
          specimenId: "Specimen ID",
          medicarePullDate: "Medicare Pull Date",
          lab_phone: "Phone",
          lab_fax: "Fax",
        },
      },
    ],
  },
  {
    title: "Shipment Information",
    sections: [
      {
        fields: {
          isTissueShipped: "Tissue Shipped",
          shipTracking: "Tracking Number",
          shipMethod: "Shipment Method",
        },
      },
    ],
  },
];

// --- CLINICAL INFORMATION DATA CONSTANTS ---
const AdvanceADFields = [
  {
    label: "Is this patient currently being considered for FDA-approved systemic therapy to treat atopic dermatitis, and do you intend to use the results of this molecular test to help inform therapy selection?",
    name: "isConsideredForTherapy",
    type: "radio",
    options: [
      { label: "Yes", value: "Yes" },
      { label: "No", value: "No" },
    ],
  },
];

const DX_MelanomaFields = [
  {
    label: "Has the patient had a sentinel lymph node biopsy for this melanoma?",
    name: "isSentinelLymphNodeBiopsy",
    type: "radio",
    options: [
      { label: "Yes", value: "Yes" },
      { label: "No", value: "No" },
      { label: "I don't know", value: "Unknown" },
    ],
  },
  {
    label: "Lymph Node Status",
    name: "lymphNodeStatus",
    type: "suggestive",
    displayWhen: { isSentinelLymphNodeBiopsy: "Yes" },
  },
  {
    label: "Does/Did this patient have clinically palpable nodes?",
    name: "isClinicallyPalpableNodes",
    type: "radio",
    options: [
      { label: "Yes", value: "Yes" },
      { label: "No", value: "No" },
      { label: "I don't know", value: "N/A" },
    ],
  },
  {
    label: "Does/Did this patient have intransit metastasis?",
    name: "isIntrasitMetastasis",
    type: "radio",
    options: [
      { label: "Yes", value: "Yes" },
      { label: "No", value: "No" },
      { label: "I don't know", value: "N/A" },
    ],
  },
];

const MyPath_MelanomaFields = [
  {
    label: "I attest the specimen being submitted for testing is a primary cutaneous melanocytic neoplasm for which the diagnosis is uncertain, (despite the performance of standard-of-care test procedures and relevant ancillary tests), the patient may be subjected to additional intervention as a result of the diagnostic uncertainty, and this patient was not receiving immunosuppressant or radiation therapy at the time of biopsy.",
    name: "isPrimaryCutaneousMelanocyticNeoplasm",
    type: "radio",
    options: [
      { label: "Yes", value: "Yes" },
      { label: "No", value: "No" },
    ],
  },
];

const UM_UMSEQFields = [
  {
    label: "Has the tissue in this sample been exposed to radiation?",
    name: "isExposedToRadiation",
    type: "radio",
    options: [
      { label: "Yes", value: "Yes" },
      { label: "No", value: "No" },
      { label: "I don't know", value: "N/A" },
    ],
  },
  {
    label: "Add-On Testing: DecisionDx-Prame",
    name: "isReportPrame",
    type: "radio",
    // displayWhen: { testTypeId: [4, 7] },
    options: [
      { label: "Yes", value: "Yes" },
      { label: "No", value: "No" },
    ],
  },
];

// --- 3. HELPER COMPONENTS ---

// *** UPDATED FIELD ROW ***
const FieldRow = ({ label, value }: { label: string; value: any }) => {
  let displayVal = value;

  // Explicitly check for boolean true/false and convert to string
  if (value === true) displayVal = "Yes";
  if (value === false) displayVal = "No";

  return (
    <div className="field-row">
      <div className="field-label">{label}</div>
      <div className="field-val">{displayVal || "---"}</div>
    </div>
  );
};

// Generic Card
function SectionCard({ title, fields, values, children, className }: any) {
  if (!fields && !children) return null;

  // Split fields for columns if they exist
  let left: any = [],
    right: any = [];
  if (fields) {
    const fieldEntries = Object.entries(fields);
    const mid = Math.ceil(fieldEntries.length / 2);
    left = fieldEntries.slice(0, mid);
    right = fieldEntries.slice(mid);
  }

  return (
    <div className={`section-card ${className || ""}`}>
      <div className="card-header">
        <span className="header-bullet"></span>
        <span className="header-title">{title}</span>
      </div>

      {children}

      {fields && (
        <div className="fields-grid">
          <div className="field-col">
            {left.map(([key, label]: any) => (
              <FieldRow key={key} label={label} value={values[key]} />
            ))}
          </div>
          {right.length > 0 && (
            <div className="field-col">
              {right.map(([key, label]: any) => (
                <FieldRow key={key} label={label} value={values[key]} />
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

// *** NEW: Custom Card for Additional Clinician Array ***
// This iterates over the array of objects provided in values.additionalClinician
function AdditionalClinicianCard({ title, clinicianData }: any) {
  // If no data, return empty or placeholder
  if (!clinicianData || clinicianData.length === 0) {
    return (
      <div className="additionalNotes-card">
        <span className="additionalNotes-title">{title}</span>

        <div className="additionalNotes-subtitle">
          No additional clinicians added.
        </div>
      </div>
    );
  }

  return (
    <div className="additionalNotes-card ">
      {/* <span className="header-bullet"></span> */}
      <span className="additionalNotes-title">{title}</span>
      <span className="additionalNotes-subtitle">
        Additional Clinician (to receive the final report)
      </span>

      {clinicianData.map((clin: any, index: number) => (
        <div
          key={index}
          style={{
            marginBottom: index !== clinicianData.length - 1 ? "12px" : "0",
            paddingBottom: index !== clinicianData.length - 1 ? "8px" : "0",
            borderBottom:
              index !== clinicianData.length - 1
                ? "1px dashed #e5e7eb"
                : "none",
          }}
        >
          <div className="fields-grid">
            <div className="field-col">
              <FieldRow
                label="Full Name"
                value={`${clin.firstName} ${clin.lastName}`}
              />
              <FieldRow label="Email" value={clin.email} />
            </div>
            <div className="field-col">
              <FieldRow label="NPI" value={clin.npi} />
              <FieldRow label="Fax" value={clin.fax} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

// --- SPECIFIC SECTIONS ---

function PatientInfoSection({ values }: any) {
  const demoFields =
    data.find((d) => d.title === "Patient Information")?.sections[0].fields ||
    {};
  const contactFields =
    data.find((d) => d.title === "Patient Information")?.sections[1].fields ||
    {};

  return (
    <div className="section-card patient-info-card" style={{ flex: 1 }}>
      <div className="card-header">
        <span className="header-bullet"></span>
        <span className="header-title">Patient Information</span>
      </div>
      <div className="fields-grid">
        <div className="field-col">
          {Object.entries(demoFields).map(([k, l]: any) => (
            <FieldRow key={k} label={l} value={values[k]} />
          ))}
        </div>
        <div className="field-col">
          {Object.entries(contactFields).map(([k, l]: any) => (
            <FieldRow key={k} label={l} value={values[k]} />
          ))}
        </div>
      </div>
    </div>
  );
}

function ClinicianInfoSection({ isSummary, isApproval, values }: any) {
  const {
    state: { selectedOrganizationData, selectedPhysicianData },
  } = useContext(ApplicationState);
  const { data: states } = useStateAndCity();
  const getValue = (
    formField: string,
    objData: any,
    objField: string,
    isState = false
  ) => {
    if (isSummary || isApproval) return values[formField];
    if (!objData) return "---";
    let val = objData[objField];
    if (isState && val) {
      const found = states?.find((s: any) =>
        `${s?.name} ${s?.state_code}`.includes(val)
      );
      val = found?.name || val;
    }
    return val;
  };

  const physFields = [
    {
      label: "Name",
      val:
        isSummary || isApproval
          ? values.clinician_full_name
          : selectedPhysicianData?.profile?.firstName +
          " " +
          selectedPhysicianData?.profile?.lastName,
    },
    {
      label: "NPI",
      val: getValue(
        "clinician_npi",
        selectedPhysicianData?.profile || selectedPhysicianData,
        "npi"
      ),
    },
    {
      label: "Email",
      val: getValue(
        "clinician_email",
        selectedPhysicianData?.profile || selectedPhysicianData,
        "email"
      ),
    },
    {
      label: "Phone",
      val: getValue(
        "clinician_phone",
        selectedPhysicianData?.profile || selectedPhysicianData,
        "phone"
      ),
    },
    { label: "Org Clinician ID", val: "---" },
  ];

  const orgFields = [
    {
      label: "Organization Name",
      val: getValue("organization_name", selectedOrganizationData, "name"),
    },
    {
      label: "Address",
      val: getValue(
        "organization_address",
        selectedOrganizationData,
        "address"
      ),
    },
    {
      label: "City",
      val: getValue("organization_city", selectedOrganizationData, "city"),
    },
    {
      label: "State",
      val: getValue(
        "organization_state",
        selectedOrganizationData,
        "state",
        true
      ),
    },
    {
      label: "Phone",
      val: getValue("organization_phone", selectedOrganizationData, "phone"),
    },
    {
      label: "Fax",
      val: getValue("organization_fax", selectedOrganizationData, "fax"),
    },
  ];

  return (
    <div className="section-card">
      <div className="card-header">
        <span className="header-bullet"></span>
        <span className="header-title">Physician's Clinical Details</span>
      </div>
      <div className="fields-grid">
        <div
          className="field-col"
          style={{ borderRight: "1px solid #e5e7eb", paddingRight: "16px" }}
        >
          {physFields.map((f, i) => (
            <FieldRow key={i} label={f.label} value={f.val} />
          ))}
        </div>
        <div className="field-col" style={{ paddingLeft: "16px" }}>
          {orgFields.map((f, i) => (
            <FieldRow key={i} label={f.label} value={f.val} />
          ))}
        </div>
      </div>
    </div>
  );
}

// Helper function to check if a field should be displayed based on displayWhen conditions
function shouldDisplayField(field: any, values: any): boolean {
  if (!field.displayWhen) return true;

  const conditions = field.displayWhen;
  for (const [key, expectedValue] of Object.entries(conditions)) {
    const actualValue = values[key];

    if (Array.isArray(expectedValue)) {
      if (!expectedValue.includes(actualValue)) return false;
    } else {
      if (actualValue !== expectedValue) return false;
    }
  }

  return true;
}

function formatRequiredAnswer(
  answer: string,
  options: RadioOptions[]
): string {
  if (!answer) return "---";
  return options.find((item) => item.value === answer)?.label ?? answer;
}

function getSccAdditionalSelectionLabel(
  value: string,
  options: RadioOptions[]
): string {
  if (value === "Specific high-risk sub-types") {
    return SCC_AGGRESSIVE_SUBTYPE_FOOTNOTE;
  }
  const option = options.find((item) => item.value === value);
  return (
    option?.label
      ?.replace(/<br\s*\/?>/gi, " ")
      .replace(/<[^>]*>/g, "")
      .replace(/\s+/g, " ")
      .trim() ?? value
  );
}

function renderAdditionalSelections(
  values: string[],
  options: RadioOptions[]
): JSX.Element[] | null {
  if (!values?.length) return null;
  return values.map((value) => (
    <div key={value} className="scc-additional-item">
      {getSccAdditionalSelectionLabel(value, options)}
    </div>
  ));
}

function SCCPdfClinicalInformation({ values }: { values: any }) {
  const { historyPhysicalExam, pathologySurgicalFindings } =
    normalizeSccClinicalSectionsFromApi(values);

  const additionalHistory =
    historyPhysicalExam.additionalHistoryPhysicalExam ?? [];
  const additionalPathology =
    pathologySurgicalFindings.additionalPathologySurgicalFindings ?? [];

  const renderRequired = (fieldKey: string, answer: string) => (
    <div key={fieldKey} className="scc-required-block">
      <div className="scc-required-question">
        {SCC_REQUIRED_FIELD_LABELS[fieldKey]}
      </div>
      <div className="scc-required-answer">{answer || "---"}</div>
    </div>
  );

  return (
    <div className="section-card" style={{ flex: 1, width: "100%" }}>
      <div className="card-header">
        <span className="header-bullet"></span>
        <span className="header-title">Clinical Information</span>
      </div>
      <div className="scc-clinical-grid">
        <div className="scc-clinical-col">
          <div className="scc-section-heading">REQUIRED SECTION</div>
          <div className="scc-subsection-heading">History and Physical Exam:</div>
          {SCC_REQUIRED_HISTORY_QUESTIONS.map((question) => {
            const fieldKey = question.name.split(".").pop() ?? "";
            const answer =
              historyPhysicalExam[
                fieldKey as keyof typeof historyPhysicalExam
              ] as string;
            return renderRequired(
              fieldKey,
              formatRequiredAnswer(answer, [...question.options])
            );
          })}
          <div className="scc-subsection-heading scc-subsection-heading-spaced">
            Surgical and Pathological Findings:
          </div>
          {SCC_REQUIRED_PATHOLOGY_QUESTIONS.map((question) => {
            const fieldKey = question.name.split(".").pop() ?? "";
            const answer =
              pathologySurgicalFindings[
                fieldKey as keyof typeof pathologySurgicalFindings
              ] as string;
            return renderRequired(
              fieldKey,
              formatRequiredAnswer(answer, [...question.options])
            );
          })}
        </div>
        <div className="scc-clinical-col">
          <div className="scc-section-heading">ADDITIONAL HIGH RISK FEATURES</div>
          <div className="scc-subsection-heading">History and Physical Exam:</div>
          {additionalHistory.length > 0 ? (
            renderAdditionalSelections(
              additionalHistory,
              SCC_ADDITIONAL_HISTORY_OPTIONS
            )
          ) : (
            <div className="scc-additional-empty">---</div>
          )}
          <div className="scc-subsection-heading scc-subsection-heading-spaced">
            Surgical and Pathological Findings:
          </div>
          {additionalPathology.length > 0 ? (
            renderAdditionalSelections(
              additionalPathology,
              SCC_ADDITIONAL_PATHOLOGY_OPTIONS
            )
          ) : (
            <div className="scc-additional-empty">---</div>
          )}
          <div className="scc-additional-footnote">
            {SCC_AGGRESSIVE_SUBTYPE_FOOTNOTE}
          </div>
        </div>
      </div>
    </div>
  );
}

// Dynamic Clinical Information Component
function ClinicalInformation({ values, testTypeId }: any) {
  const numericTestTypeId = Number(
    testTypeId ?? values?.testTypeId ?? values?.selectedTest?.id
  );

  if (numericTestTypeId === 2) {
    return <SCCPdfClinicalInformation values={values} />;
  }

  // Determine which field set to use based on testTypeId
  let fields: any[] = [];
  let heading = "";

  switch (numericTestTypeId) {
    case 9: // AdvanceAD-Tx
      fields = AdvanceADFields;
      break;
    case 3: // DecisionDx-Melanoma
    case 6:
      fields = DX_MelanomaFields;
      break;
    case 5: // MyPath Melanoma
      fields = MyPath_MelanomaFields;
      break;
    case 4: // DecisionDx-UM
    case 7: // UMSEQ
      fields = UM_UMSEQFields;
      break;
    default:
      // No clinical information for this test type
      return null;
  }

  if (!fields || fields.length === 0) return null;

  return (
    <div className="section-card" style={{ flex: 1 }}>
      <div className="card-header">
        <span className="header-bullet"></span>
        <span className="header-title">Clinical Information</span>
      </div>

      {heading && (
        <div style={{
          fontSize: "8px",
          color: "#475467",
          marginBottom: "10px",
          fontWeight: 500
        }}>
          {heading}
        </div>
      )}

      <div className="fields-grid">
        <div className="field-col">
          {fields.map((field, idx) => {
            // Check if field should be displayed
            if (!shouldDisplayField(field, values)) return null;

            // Handle checkbox type - show only selected values
            if (field.type === "checkbox") {
              const selectedValues = values[field.name] || [];

              // If no values selected, skip this field
              if (!Array.isArray(selectedValues) || selectedValues.length === 0) {
                return null;
              }

              return (
                <div key={idx} style={{ marginBottom: "12px" }}>
                  <div className="field-label" style={{
                    fontWeight: 600,
                    marginBottom: "6px",
                    width: "100%"
                  }}>
                    {field.label}
                  </div>
                  <div className="field-val" style={{
                    paddingLeft: "8px",
                    lineHeight: "1.5"
                  }}>
                    {selectedValues.join(", ")}
                  </div>
                </div>
              );
            }

            // Handle radio type
            if (field.type === "radio") {
              const selectedValue = values[field.name] || "---";

              return (
                <div key={idx} style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: "8px",
                  alignItems: "flex-start"
                }}>
                  <div className="field-label" style={{ width: "65%" }}>
                    {field.label}
                  </div>
                  <div className="field-val" style={{ fontWeight: 600 }}>
                    {selectedValue}
                  </div>
                </div>
              );
            }

            // Handle suggestive type (dropdown/select)
            if (field.type === "suggestive") {
              const selectedValue = values[field.name] || "---";

              return (
                <div key={idx} style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: "8px",
                }}>
                  <div className="field-label" style={{ width: "45%" }}>
                    {field.label}
                  </div>
                  <div className="field-val">
                    {selectedValue}
                  </div>
                </div>
              );
            }

            return null;
          })}
        </div>
      </div>
    </div>
  );
}

export const printRef = React.createRef<any>();

function OnlineOrderPDF({
  values,
  isSummary,
  isApproval,
  formId,
  customRef,
  isVisible,
}: any): JSX.Element {
  // Name segments: first part before first ":" (matches backend testTypeTitle)
  const primaryNameSegment =
    (values?.selectedTest?.name ?? "").split(":")[0]?.trim() || "---";
  const secondaryNameSegment =
    (values?.secondaryTestType?.name ?? "").split(":")[0]?.trim() || "---";

  const allThreeMet =
    values?.testTypeId == 4 &&
    values?.secondaryTestTypeId == 7 &&
    values?.isReportPrame === "Yes";
  const isReportPrameNoSecondary =
    values?.isReportPrame === "Yes" &&
    !values?.secondaryTestTypeId &&
    !values?.secondaryTestType;

  // Single computed title for header "ORDER TYPE" and eRequest "generated for" line
  let orderTypeTitle: string;
  if (allThreeMet) {
    orderTypeTitle = `${primaryNameSegment} : ${secondaryNameSegment} : DecisionDX-PRAME`;
  } else if (
    values?.testTypeId == 4 &&
    values?.isReportPrame === "Yes"
  ) {
    orderTypeTitle = `${primaryNameSegment} : DecisionDX-PRAME`;
  } else if (values?.secondaryTestType?.name) {
    orderTypeTitle = `${primaryNameSegment} : ${secondaryNameSegment}`;
  } else {
    orderTypeTitle = primaryNameSegment;
  }

  // Logo URLs for conditional header display (PRAME from BE testType.DecisionDxPRAMELogo)
  const primaryLogoUrl = values?.selectedTest?.imageUrl;
  const secondaryLogoUrl = values?.secondaryTestType?.imageUrl;
  const prameLogoUrl = values?.selectedTest?.DecisionDxPRAMELogo;

  const billingData = data.find((d) => d.title === "Billing information")
    ?.sections[0];
  const labData = data.find((d) => d.title === "Laboratory Information");
  const shipData = data.find((d) => d.title === "Shipment Information")
    ?.sections[0];

  // Array of additional clinicians
  const additionalClinicianArray = values?.additionalClinician || [];
  const numericTestTypeId = Number(
    values?.testTypeId ?? values?.selectedTest?.id
  );
  const clinicalTestTypeId = values?.testTypeId ?? values?.selectedTest?.id;

  return (
    <Fragment>
      <style>{pdfStyles}</style>

      <div
        ref={customRef ?? printRef}
        id={formId ?? "pdf"}
        className={`${isVisible ? "" : "hidden"} order-print-wrapper`}
      >
        <div id="pdf-container">
          {/* 1. Header */}
          <div className="header-container">
            <div className="org-info-container">
              <div className="company-logo-wrapper">
                <LogoSVG height={35} width={100} />
              </div>
              <div className="company-address">
                8667 E Hartford Dr. Ste 110, Scottsdale, AZ 85255
              </div>
              <div className="company-phone">
                Customer Service:{" "}
                <span className="phone-number" style={{ color: "#18b5b7" }}>
                  866-788-9007
                </span>
              </div>
              <div className="generated-date">
                Generated: {new Date().toLocaleDateString()} (Version 1.0.0)
              </div>
            </div>

            {/* *** UPDATED: Header Right Section for Vertical Logo Stacking *** */}
            <div className="header-right-section">
              <div className="order-type-box">
                <div className="header-logos-column">
                  {allThreeMet && (
                    <>
                      {secondaryLogoUrl && (
                        <img
                          src={secondaryLogoUrl}
                          alt="Secondary Test Logo"
                          className="order-type-image"
                        />
                      )}
                    {prameLogoUrl && (
                      <img
                        src={prameLogoUrl}
                        alt="DecisionDX-PRAME"
                        className="order-type-image"
                      />
                    )}
                  </>
                )}
                {isReportPrameNoSecondary && (
                    <>
                      {primaryLogoUrl && (
                        <img
                          src={primaryLogoUrl}
                          alt="Test Logo"
                          className="order-type-image"
                        />
                      )}
                    {prameLogoUrl && (
                      <img
                        src={prameLogoUrl}
                        alt="DecisionDX-PRAME"
                        className="order-type-image"
                      />
                    )}
                  </>
                )}
                {!allThreeMet && !isReportPrameNoSecondary && (
                    <>
                      {primaryLogoUrl && (
                        <img
                          src={primaryLogoUrl}
                          alt="Test Logo"
                          className="order-type-image"
                        />
                      )}
                      {secondaryLogoUrl && (
                        <img
                          src={secondaryLogoUrl}
                          alt="Secondary Test Logo"
                          className="order-type-image"
                        />
                      )}
                    </>
                  )}
                </div>
                <div className="order-type-label">ORDER TYPE</div>
                <div className="order-type-value">{orderTypeTitle}</div>
              </div>
            </div>
          </div>

          {/* 2. Status Row */}
          <div className="status-bar">
            <div className="flex flex-col">
              <div>
                <span className="onlineOrderHeading">
                  Online Ordering eRequest generated for:{" "}
                  {orderTypeTitle}
                </span>
              </div>
              <div className="flex flex-row">
                <div className="status-item">
                  <span className="status-label">
                    eRequest Transmission Status:
                  </span>
                  <span className="status-val">
                    {values?.orderStatus || "Pending"}
                  </span>
                </div>
                <div className="status-separator">|</div>
                <div className="status-item">
                  <span className="status-label">Date Transmitted:</span>
                  <span className="status-val">
                    {values?.submittedDate || "---"}
                  </span>
                </div>
                <div className="status-separator">|</div>
                <div className="status-item">
                  <span className="status-label">Order Confirmation #:</span>
                  <span className="status-val">{values.eRequestId}</span>
                </div>
              </div>
            </div>
          </div>

          {/* 3. Patient Info (Full Row) */}
          <div className="section-row">
            <PatientInfoSection values={values} />
          </div>

          {/* 4. Physician & Org (Full Row) */}
          <div className="section-row">
            <ClinicianInfoSection
              isApproval={isApproval}
              isSummary={isSummary}
              values={values}
            />
          </div>

          {/* 5. Billing (and Clinical for non-SCC test types) */}
          <div className="section-row">
            <SectionCard
              title="Billing Information"
              fields={billingData?.fields}
              values={values}
            />
            {numericTestTypeId !== 2 && (
              <ClinicalInformation
                values={values}
                testTypeId={clinicalTestTypeId}
              />
            )}
          </div>

          {/* 5b. SCC Clinical Information (full width) */}
          {numericTestTypeId === 2 && (
            <div className="section-row">
              <ClinicalInformation
                values={values}
                testTypeId={clinicalTestTypeId}
              />
            </div>
          )}

          {/* 6. GRID ROW: Laboratory | Shipment */}
          <div className="section-row lab-shipment-section-row">
            <SectionCard
              title="Laboratory Information"
              fields={labData?.sections[0]?.fields}
              values={values}
            >
              {/* Custom Subtitle Row */}
              <div className="field-row" style={{ marginBottom: "10px" }}>
                <div className="field-label" style={{ width: "auto" }}>
                  Type of specimen submitted for testing:
                </div>
                <div className="field-val" style={{ textAlign: "right" }}>
                  Slides/Block
                </div>
              </div>
            </SectionCard>

            <SectionCard
              title="Shipment Information"
              fields={shipData?.fields}
              values={values}
            />
          </div>

          {/* 7. GRID ROW: Additional Info (Array) | Additional Notes */}
          <div className="section-row">
            {/* Left Side: Additional Clinician (Maps Array via new Component) */}
            <AdditionalClinicianCard
              title="Additional Information"
              clinicianData={additionalClinicianArray}
            />

            {/* Right Side: Notes */}
            <div className="additionalNotes-card">
              <span className="additionalNotes-title">Additional Notes</span>
              <div className="additionalNotes-subtitle">
                {values.additional_notes || "..."}
              </div>
            </div>
          </div>

          {/* 8. Signature Section */}
          <div
            className="footer-section"
            style={{ background: "#eaecf0", borderColor: "#18B5B7", padding: "12px" }}
          >
            <div className="card-header" style={{ marginBottom: "8px" }}>
              <span className="header-bullet"></span>
              <span className="header-title" style={{ textTransform: 'uppercase' }}>
                E-Signature
              </span>
            </div>

            {/* {signature?.viewableURL ? (
    <div className="signature-content" style={{ paddingLeft: "18px" }}>
      <div className="signature-image-container" style={{ marginBottom: "8px" }}>
        <img
          src={signature.viewableURL}
          alt="Provider Signature"
          className="signature-image"
          style={{ maxHeight: "60px", display: "block" }}
        />
      </div>

      <div style={{ fontSize: "11px", color: "#344054" }}>
        <div style={{ marginBottom: "2px" }}>
          <strong>Signed at:</strong> {values?.submittedDate || new Date().toLocaleDateString()}
        </div>
        <div>
          <strong>Signed By:</strong>{" "}
          {`${values?.physicianName}`}
        </div>
      </div>
    </div>
  ) : ( */}
            <div
              className="placeholder-text"
              style={{
                paddingLeft: "18px",
                fontSize: "14px",
                color: "#667085",
                marginTop: "4px"
              }}
            >
              _______________
            </div>
            {/* )} */}
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default OnlineOrderPDF;
